<template>
  <div class="tan px_kcadd">
    <div class="px_add_con" style="height: 460px;">
      <div class="h250 rdiv">
        <h3>签到二维码</h3>
        <a href="javascript:void(0);" class="close" @click="$emit('close')"></a>
        <div style="position: relative; height: 250px; margin-top: 35px; text-align: center;">
          <qrcode-vue id="print" :value="value" :size="size" level="H"></qrcode-vue>
        </div>
      </div>
      <div class="clear"></div>
      <div class="w240 wrap">
        <input name="" type="button" value="打印" class="all_btn" @click="print" />
        <input name="" type="button" value="关闭" @click="$emit('close')" class="all_btn color_hui" />
      </div>
    </div>
  </div>
</template>
<script>
  import QrcodeVue from 'qrcode.vue'
  import Vue from 'vue'
  export default {
    props: {
      id:{
        type: String
      }
    },
    data() {
      return {
        value: this.id,
        size: 150
      }
    },
    components: {
      QrcodeVue
    },
    methods: {
      print () {
        var newWin = window.open(""); //新打开一个空窗口
        var canvas = $("#print").children('canvas').get(0); //将要被打印的图片
        let dataURL = canvas.toDataURL("image/png"); //转图片  隐藏canvas
        let img = '<img style="width: 300px;" src="' + dataURL + '"/>';
        newWin.document.write(img); //将图片添加进新的窗口
        newWin.document.close(); //在IE浏览器中使用必须添加这一句
        newWin.focus(); //在IE浏览器中使用必须添加这一句
        setTimeout(function() {
          newWin.print(); //打印
          newWin.close(); //关闭窗口
        }, 100);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/byl/org/enroll/qrcode.vue